export default "images/carInfo.png";